import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { PACKAGING_IMAGE, BRAND_STORY_IMAGE, PRODUCTS } from "@/data/products";
import { useMedia } from "@/context/MediaContext";

export default function EditorialCards() {
  const img = useMedia();
  const cards = [
    { key: "gifting", image: img("packaging", PACKAGING_IMAGE), title: "The Art of Gifting", text: "Every bottle arrives in its signature black box with a gold-foiled sleeve — ready to be given, no wrapping needed.", cta: "Shop gifts", to: "/collections" },
    { key: "maturation", image: img("brand_story", BRAND_STORY_IMAGE), title: "Matured 8–10 Weeks", text: "Each composition rests for up to ten weeks before bottling, so the notes settle into one seamless accord.", cta: "Our process", to: "/experience" },
    { key: "delivery", image: PRODUCTS[2].aestheticImage, title: "Complimentary Delivery", text: "Free shipping across India on orders above ₹999, with secure Razorpay payment and live order tracking.", cta: "Track an order", to: "/track-order" },
  ];
  return (
    <section data-testid="editorial-cards-section" className="max-w-[1440px] mx-auto px-5 md:px-10 py-20 md:py-28">
      <div className="grid md:grid-cols-3 gap-8 md:gap-10">
        {cards.map((c, i) => (
          <Reveal key={c.key} delay={i * 0.1}>
            <Link to={c.to} data-testid={`editorial-card-${c.key}`} className="group block">
              <div className="aspect-[4/3] overflow-hidden bg-[#EFE9E1]">
                <img src={c.image} alt={c.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
              </div>
              <h3 className="mt-6 font-serif-brand text-2xl md:text-3xl font-light">{c.title}</h3>
              <p className="mt-3 text-sm text-black/55 leading-relaxed">{c.text}</p>
              <span className="mt-4 inline-block link-line text-[0.68rem] uppercase tracking-[0.22em] font-medium">{c.cta}</span>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
